// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function isNonEmptyEnvVar(envVarValue: any): envVarValue is string {
  return typeof envVarValue === 'string' && envVarValue.trim().length >= 1;
}
